export default __webpack_public_path__ + "static/media/image-fisheye.8bb3f74e.jpg";